<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/analsis/chart' }">数据概览</el-breadcrumb-item>
      <el-breadcrumb-item>公司异常</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="switchArea" v-if="userInfo.permission==1">
      <el-select v-model="region_id" placeholder="筛选地区" @change="getList()">
        <el-option
          v-for="item in regionList"
          :key="item.region_id"
          :label="item.region_name"
          :value="item.region_id">
        </el-option>
      </el-select>
    </div>
    <div class="listWrap">
      <el-table
        :data="firmList.filter(data => !search || data.company_name.toLowerCase().includes(search.toLowerCase()))"
        style="width:100%;">
        <el-table-column label="公司名称" prop="company_name" width="360px"></el-table-column>
        <el-table-column label="废气治理措施异常" prop="gas_type"
        :filter-method="filterHandler"
        :filters="[{text: '正常', value: 0},{text: '异常', value: 1}]">
          <template slot-scope="scope1">
            <el-tag
              :type="typeObj[scope1.row.gas_type].type"
              disable-transitions>{{scope1.row.gas_type==0?'正常':'异常'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="废水治理措施异常" prop="water_type"
        :filter-method="filterHandler"
        :filters="[{text: '正常', value: 0},{text: '异常', value: 1}]">
          <template slot-scope="scope2">
            <el-tag
              :type="typeObj[scope2.row.water_type].type"
              disable-transitions>{{scope2.row.water_type==0?'正常':'异常'}}</el-tag>
          </template>          
        </el-table-column>
        <!-- <el-table-column label="危险废物管理异常" prop="goods_type"
        :filter-method="filterHandler"
        :filters="[{text: '正常', value: 0},{text: '异常', value: 1}]">
          <template slot-scope="scope3">
            <el-tag
              :type="typeObj[scope3.row.goods_type].type"
              disable-transitions>{{scope3.row.goods_type==0?'正常':'异常'}}</el-tag>
          </template>          
        </el-table-column> -->
        <el-table-column label="公司日常运行管理异常" prop="usual_type"
        :filter-method="filterHandler"
        :filters="[{text: '正常', value: 0},{text: '异常', value: 1}]">
          <template slot-scope="scope4">
            <el-tag
              :type="typeObj[scope4.row.usual_type].type"
              disable-transitions>{{scope4.row.usual_type==0?'正常':'异常'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="输入关键字搜索"/>
          </template>
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="handleCheck(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        @current-change="handleCurrentChange"
        :total="last_page * 10">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeObj: [
        {type: 'primary'},
        {type: 'danger'},
      ],
      firmList: [],
      currentPage: 1,
      last_page: 1,
      search: '',
      region_id: '',
      regionList: [],
      userInfo: ''
    }
  },
  methods: { 
    handleCheck(index, row) {
      window.sessionStorage.setItem('firmInfo_pollution', JSON.stringify(this.firmList[index]))
      this.$router.push({path: '/pollution/check'})
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    handleCurrentChange(val) {
      console.log(val)
      this.currentPage = val
      this.getList()
    },
    getList(){
      let that = this
      this.$http.get('api/scwrfz/get?isyc=1&page=' + that.currentPage + '&region_id=' + that.region_id)
      .then(function(res) {
        console.log(res.data.data.data)
        that.firmList = res.data.data.data
        for(let i=0;i<res.data.data.data.length;i++){
          that.firmList[i].gas_content = JSON.parse(that.firmList[i].gas_content)
          that.firmList[i].water_content = JSON.parse(that.firmList[i].water_content)
          that.firmList[i].goods_content = JSON.parse(that.firmList[i].goods_content)
          that.firmList[i].usual_content = JSON.parse(that.firmList[i].usual_content)
        }
        if(that.currentPage == 1){
          that.$message.success('获取列表成功！')
          that.last_page = res.data.data.last_page
        }
      })
    },
    getRegion(){
      let that = this
      this.$http.get('api/region/getAll')
      .then(function(res) {
        that.regionList = res.data.data
        console.log(res.data.data)
        if(res.data.code != 1){
          that.$$message.warning('获取地区列表异常，请重试！')
        }
      })
    }
  },
  created() {
    this.getList()
    this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo_mine'))
    this.getRegion()
  },
}
</script>
<style scoped>
  .listWrap{
    margin-top: 50px;
  }
  .addBtn{
    position: absolute;
    right: 30px;
  }
  .table{
    height: 200px;
  }
  .el-pagination{
    margin-top: 30px;
    position: absolute;
    left: 50%;
    transform: translateY(-50%);
  }
  .switchArea{
    position: absolute;
    margin-top: -5px;
    right: 20px;
  }
</style>